import { render, staticRenderFns } from "./PageFourteenth.vue?vue&type=template&id=85cb3e94&scoped=true"
import script from "./PageFourteenth.vue?vue&type=script&lang=js"
export * from "./PageFourteenth.vue?vue&type=script&lang=js"
import style0 from "./PageFourteenth.vue?vue&type=style&index=0&id=85cb3e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cb3e94",
  null
  
)

export default component.exports